import itemToBag from "./itemToBag";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
const { moveItemToBagRequestTimeout: requestTimeout } =
  clientConfigurationProvider();

const toBagOperation = (sdkInstance, { variantId, id: savedItemId, seller }) =>
  sdkInstance.moveToBag({ variantId, savedItemId, seller });

export default itemToBag({ toBagOperation, requestTimeout });
